<template>
  <div class="boxFile" :class="{ 'uploading': loadingUpload }">
    <TextInput
      :hide-input="iValue"
      type="file"
      :label="label"
      accept="image/*"
      @changed="(file) => choosedFile(file)"
    />
    <div class="text-left mb-3" :style="{ marginTop: (iValue ? '-1rem' : 0) }">
      <img
        v-if="readyImage"
        :src="readyImage"
        alt="Preview"
        :style="{ height: '180px', cursor: skipRatioCheck ? 'default' : 'pointer' }"
        :class="{ 'full-width': fullWidth }"
        @click="handleImageClick"
      />
      <CropperModal
        v-if="showCropper"
        :imageUrl="tempImage"
        :isFavIcon="isFavIcon"
        @cropped="handleCropResult"
        @close="showCropper = false"
      />
      <div v-if="iValue" class="mt-2">
        <b-button variant="outline-danger" size="sm" @click="deleteFile">Delete</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import './Styles/UploadImage.scss'

export default {
  props: {
    value: { type: String, default: null },
    label: { type: String, default: null },
    fullWidth: { type: Boolean, default: false },
    skipRatioCheck: { type: Boolean, default: false },
    landingId: { type: [String, Number], default: null },
    isFavIcon: { type: Boolean, default: false },
  },
  data() {
    return {
      loadingUpload: false,
      tempImage: null,
      readyImage: null,
      showCropper: false, // show modal state
    }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    }
  },
  mounted() {
    this.readyImage = this.value
  },
  watch: {
    value(newVal) {
      this.readyImage = newVal
    }
  },
  methods: {
    choosedFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.tempImage = e.target.result;
        if (!this.skipRatioCheck) {
          this.showCropper = true;
        } else {
          // Directly upload without cropping
          this.uploadImage(file);
        }
      };
      reader.readAsDataURL(file);
    },
    handleImageClick() {
      if (!this.skipRatioCheck) {
        this.tempImage = this.readyImage; 
        this.showCropper = true;
      }
    },   
    handleCropResult(blob) {
      this.showCropper = false
      // Create a preview URL for the cropped image
      const reader = new FileReader();
      reader.onload = (e) => {
        this.tempImage = e.target.result;
        this.uploadImage(blob);
      }
      reader.readAsDataURL(blob);
    },
    uploadImage(file) {
      this.loadingUpload = true;
      let uploadForm = new FormData();
      const title = this.$parent?.blog?.description || 'blog-image';

      uploadForm.append('file', file);
      uploadForm.append('image_prompt', title);
      uploadForm.append('landing_id', this.landingId ?? this.$parent?.landing?.id ?? null);

      this.$store.dispatch('image/uploadNonConvertImage', uploadForm)
        .then((response) => {
          this.iValue = response.url;
          this.readyImage = response.url;
        })
        .catch((err) => {
          alert(err?.response?.data?.error || "Upload failed.");
        })
        .finally(() => {
          this.loadingUpload = false;
        });
    },
    deleteFile() {
      this.iValue = null;
      this.tempImage = null;
      this.readyImage = null;
    }
  }
}
</script>
